/**
 * Centralized configuration for the application
 * Contains all constants, settings, and configuration values
 */

export const CONFIG = {
    // Filter system configuration
    FILTER: {
        // Text input filtering configuration
        TEXT_INPUT: {
            DEBOUNCE_DELAY: 500,
            MIN_LENGTH: 3
        }
    },

    // Toastr notification configuration
    TOASTR: {
        TIMEOUT: 5000,
        EXTENDED_TIMEOUT: 1000,
        SHOW_DURATION: 300,
        HIDE_DURATION: 1000,
        POSITION: 'toast-top-full-width'
    },

    // Grid and UI selectors
    SELECTORS: {
        GRID: '#grid',
        FILTER_FORM: '#filter',
        CLEAR_FILTERS_BTN: '#clearFiltersBtn',
        FILTER_BTN: '#filterBtn'
    },

    // Cookie configuration
    COOKIES: {
        DEFAULT_EXPIRY_DAYS: 365,
        SIDEBAR_STATE: 'SidebarCollapseState'
    },

    // Kendo UI configuration
    KENDO: {
        CULTURE: 'cs-CZ',
        DATE_FORMAT: 'd. M. yyyy',
        DATE_PARSE_FORMATS: ['d.M.yyyy', 'dd.MM.yyyy', 'dd. MM. yyyy'],
        DATETIME_FORMAT: 'dddd, d. MMMM yyyy',
        TIME_FORMAT: 'HH:mm',
        TIME_PARSE_FORMATS: ['H:mm', 'HH', 'H'],
        FULL_TIME_FORMAT: 'HH:mm:ss'
    },

    // Error handling
    ERROR: {
        FALLBACK_MESSAGE: 'Došlo k chybě.',
        ACCESS_DENIED_MESSAGE: 'Nemáš oprávnění provést tuto akci.',
        SESSION_EXPIRED_MESSAGE:
            'Z důvodu delší nečinnosti došlo k odhlášení z aplikace.<br/>Přihlas se prosím znovu.',
        LOGIN_URL: '/Identity/Account/Login',
        REDIRECT_DELAY_MS: 3000,
        MAX_ERRORS: 10
    },

    // Antiforgery configuration
    ANTIFORGERY: {
        TOKEN_INPUT_NAME: '__RequestVerificationToken',
        TOKEN_META_NAME: 'csrf-token',
        COOKIE_NAME: 'XSRF-TOKEN',
        HEADER_NAME: 'RequestVerificationToken'
    },

    // Filter values configuration
    FILTER_VALUES: {
        GRID_SELECTOR: '.k-grid'
    },

    // Session storage configuration
    SESSION_STORAGE: {
        FILTER_PREFIX: 'filter_',
        MAX_AGE_DAYS: 7,
        GRID_PREFIX: 'grid_'
    },

    // Grid persistence configuration
    GRID: {
        PERSISTENCE_ENABLED: true,
        SAVE_DEBOUNCE_MS: 0,
        SAFE_COLUMNS_ONLY: true,
        MAX_WAIT_ATTEMPTS: 50,
        WAIT_INTERVAL_MS: 100
    },

    // Utility functions configuration
    UTILS: {
        WAIT_FOR_CONDITION: {
            DEFAULT_TIMEOUT_MS: 5000,
            DEFAULT_INTERVAL_MS: 100
        }
    }
};

/**
 * Environment detection utilities
 */
export const ENV = {
    // Development environment detection constants
    DEVELOPMENT_HOSTS: ['localhost', '127.0.0.1'],
    DEVELOPMENT_PATTERNS: ['dev', 'test'],

    /**
     * Check if current environment is development
     * @returns {boolean}
     */
    isDevelopment() {
        const hostname = window.location.hostname;
        return (
            this.DEVELOPMENT_HOSTS.includes(hostname) ||
            this.DEVELOPMENT_PATTERNS.some(pattern => hostname.includes(pattern))
        );
    },

    /**
     * Check if current environment is production
     * @returns {boolean}
     */
    isProduction() {
        return !this.isDevelopment();
    }
};

export default CONFIG;
